import { MODULE_REGISTRY } from '../modules/registry';

export interface RbacUser {
  superadmin?: boolean;
  role?: { isFarmAdministrator: boolean; menus: string[] } | null;
  hasLinkedOperator?: boolean;
}

export function isSuperadminOnly(menuKey: string): boolean {
  const [moduleKey] = menuKey.split(':');
  return Boolean(MODULE_REGISTRY[moduleKey]?.superadminOnly);
}

export function isDefaultGranted(menuKey: string): boolean {
  const [moduleKey, menuName] = menuKey.split(':');
  const mod = MODULE_REGISTRY[moduleKey];
  if (!mod) return false;
  const menu = mod.menus.find(m => m.key === menuName);
  return Boolean(menu?.defaultGranted);
}

export function allMenuKeys(opts: { includeSuperadminOnly: boolean } = { includeSuperadminOnly: false }): string[] {
  const out: string[] = [];
  for (const mod of Object.values(MODULE_REGISTRY)) {
    if (!opts.includeSuperadminOnly && mod.superadminOnly) continue;
    for (const menu of mod.menus) out.push(`${mod.key}:${menu.key}`);
  }
  return out;
}

export function userHasAnyMenuIn(user: RbacUser | null | undefined, moduleKey: string): boolean {
  if (!user) return false;
  const mod = MODULE_REGISTRY[moduleKey];
  if (!mod) return false;
  if (user.superadmin) return true;
  if (mod.superadminOnly) return false;
  if (!user.role) return false;
  if (user.role.isFarmAdministrator) return true;
  // Phase 3.8: a pure operator (linked, no menus) still has business in the
  // Spraying module. The linkage acts as the operator grant; the module pill
  // must appear so they can reach /spray/my-sessions.
  if (moduleKey === 'spraying' && user.hasLinkedOperator) return true;
  // Module visibility requires the role to have at least one explicitly granted
  // menu in the module. defaultGranted menus (e.g. settings:user, used by the
  // language switcher in AppShell chrome) grant the menu itself but do NOT
  // make the module visible as a tile/sidebar entry.
  const prefix = `${moduleKey}:`;
  return Boolean(user.role.menus.some(k => k.startsWith(prefix)));
}
